<template>
	<span v-show="editMode">
		<a class="btn-action" title="完成" v-show="menu.editMode" @click.stop.prevent="menu.toggleEdit">
			<i class="fa fa-check text-warning f18"></i>
		</a>

		<a class="btn-action" title="编辑" v-show="!menu.editMode"
		   @click.stop.prevent="menu.toggleEdit">
			<i class="fa fa-pencil text-warning f18"></i>
		</a>

		<a class="btn-action" title="添加子菜单" v-show="menu.level===0"
		   @click.stop.prevent="menu.addField">
			<i class="fa fa-plus text-success f18"></i>
		</a>

		<a class="btn-action" title="上移" v-show="!menu.editMode" @click.stop.prevent="up">
			<i class="fa fa-arrow-up f18"></i>
		</a>

		<a class="btn-action" title="下移" v-show="!menu.editMode" @click.stop.prevent="down">
			<i class="fa fa-arrow-down f18"></i>
		</a>

		<a class="btn-action" title="删除" @click.stop.prevent="del">
			<i class="fa fa-trash text-danger f18"></i>
		</a>

	</span>
</template>

<script>
	import TopicMenu from '../../../../common/model/topic/TopicMenu'
	import {MessageBox, Notification} from 'element-ui';
	export default {
		data(){
			return {}
		},
		props: {
			editMode: {
				type: Boolean,
				required: false,
				"default": false
			},
			menu: {
				type: TopicMenu,
				required: true
			},
			container: {
				type: Array,
				required: true
			},
			index: {
				type: Number,
				required: true
			}


		},
		computed: {},
		watch: {},
		methods: {
			up(){
				if (this.index !== 0) {
					this.container.splice(this.index, 1);
					this.container.splice(this.index - 1, 0, this.menu);
				}
			},
			down(){

				if (this.index !== this.container.length - 1) {
					this.container.splice(this.index, 1);
					this.container.splice(this.index + 1, 0, this.menu);
				}

			},
			del(){
				let that = this;
				MessageBox.confirm('此操作该菜单及其子菜单，确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.container.splice(that.index, 1);
					}
				);

			}
		},
		mounted(){
		}
	}
</script>


// WEBPACK FOOTER //
// ActionButtons.vue?063520c1